import React from 'react';

export default function About() {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <div className="relative">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange rounded-lg p-1">
                <div className="bg-white rounded-lg overflow-hidden">
                  <img 
                    src="/images/services/about-image.jpg" 
                    alt="Zolo Service Office in Chhindwara" 
                    className="w-full h-auto rounded-lg"
                  />
                </div>
              </div>
              <div className="absolute -bottom-6 -right-6 bg-zolo-orange rounded-lg p-4 shadow-lg">
                <p className="text-white font-bold text-xl">Since 2020</p>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">About Zolo Service Chhindwara</h2>
            <p className="text-gray-700 mb-6 text-lg">
              Zolo Service, based in Chhindwara, Madhya Pradesh, empowers businesses with innovative digital solutions. 
              We specialize in web development, social media, graphic design, SEO, WhatsApp marketing, ads, GMB, and 
              influencer marketing to drive your growth.
            </p>
            <p className="text-gray-700 mb-8 text-lg">
              Our local roots give us unique insights into the Chhindwara market, while our digital expertise connects 
              your business to opportunities across India and beyond. We're committed to your success with personalized 
              strategies that deliver measurable results.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md transition duration-300"
            >
              Meet Our Team
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 ml-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
